/* Qty1 edit → ask the strip packing of the Second Name product and optionally store it for future orders. */
import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Package } from "lucide-react";

let _open = null;
// Promise<{mode:'save', packing} | {mode:'row'} | null>
export const askPacking = (opts) => new Promise(resolve => {
  if (!_open) { resolve({ mode: "row" }); return; }
  _open({ ...opts, resolve });
});

export const QtyPackingPromptHost = () => {
  const [req, setReq] = useState(null);
  const [val, setVal] = useState("");
  useEffect(() => {
    _open = (r) => { setVal(r.suggested || r.current || ""); setReq(r); };
    return () => { _open = null; };
  }, []);
  const close = (v) => { req?.resolve(v); setReq(null); };
  const ok = Number(val) > 0;
  return (
    <Dialog open={!!req} onOpenChange={(o) => { if (!o) close(null); }}>
      <DialogContent className="max-w-sm" data-testid="qty1-packing-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <Package className="w-4 h-4 text-indigo-600" /> Packing for this product
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2 text-sm">
          <div className="rounded-md bg-slate-50 border border-slate-200 px-2.5 py-1.5 text-xs text-slate-600 space-y-0.5">
            <div>Second Name: <b className="text-slate-800" data-testid="qty1-packing-sn">{req?.secondName}</b></div>
            <div>Current packing: <b data-testid="qty1-packing-current">{req?.current || "not set"}</b></div>
            <div>Qty {req?.qty} → Qty1 <b>{req?.qty1}</b></div>
          </div>
          <label className="text-xs text-slate-500">Pills / units per strip</label>
          <Input type="number" min="1" value={val} autoFocus onChange={e => setVal(e.target.value)}
            onKeyDown={e => { if (e.key === "Enter" && ok) close({ mode: "save", packing: val }); }}
            data-testid="qty1-packing-input" />
        </div>
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" size="sm" onClick={() => close({ mode: "row" })} data-testid="qty1-packing-row-only">Only this row</Button>
          <Button size="sm" disabled={!ok} onClick={() => close({ mode: "save", packing: val })} data-testid="qty1-packing-save">Save packing for future orders</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
